<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="chain.name" v-validate data-vv-rules="required">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Observation</label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('observation')}" name="observation" id="observation" placeholder="" v-model="chain.observation"></textarea>
          <span v-show="errors.has('observation')" class="help is-danger">{{ errors.first('observation') }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-loading': inProgress, 'is-disabled': errors.any()}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      chain_hotel_id: {
        type: Number
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        chain: {
          id: '',
          name: '',
          observation: ''
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.edit) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/chains_hotel/' + this.chain_hotel_id).then((response) => {
          this.chain.id = response.body.id
          this.chain.name = response.body.name
          this.chain.observation = response.body.observation
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      },
      async save () {
        this.$validator.validateAll().then(async () => {
          this.inProgress = true
          this.error = ''
          if (!this.edit) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/chains_hotel', this.chain).then((response) => {
              this.inProgress = false
              this.stage = 2
              this.chain.id = response.body.id
              this.close(false, {ok: true, message: this.chain.name + ' successfully created'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/chains_hotel/' + this.chain.id, this.chain).then((response) => {
              this.inProgress = false
              this.chain.id = response.body.id
              this.close(false, {ok: true, message: this.chain.name + ' successfully saved'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      babelPolyfill
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// ChainHotel.vue?5580a2d4